import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProjectPlanningRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canManageProjectPlanning } = useAuth();
  return canManageProjectPlanning ? <>{children}</> : <Navigate to="/dashboard" replace />;
};

export default ProjectPlanningRoute;
